export default class LastMessagePresenter {
  constructor(readonly id: string = '', readonly lastMessage: string = '') {}
}
